import styled from 'styled-components';

export const Svg = styled.svg`
  width: 46px;
`;
